import React from "react";

import { Flex } from "antd";
import moment, { Moment } from "moment";

import { useTranslation } from "utils";

import { Button, Icon, Typography } from "components";

type ActionBannerType = "info" | "warning" | "error";

export const ActionBanner = ({
  onClick,
  title,
  description,
  buttonLabel,
  type = "info",
  dueDate,
}: {
  onClick: () => void;
  title: string;
  description: string;
  buttonLabel: string;
  type?: ActionBannerType;
  dueDate?: Moment;
}) => {
  const { t } = useTranslation("dashboard");

  const today = moment();
  const isOverdue = today.isSameOrAfter(dueDate, "day");

  return (
    <Flex justify="space-between" align="center" className={`action-banner-container ${type}`} gap="1.5rem">
      <div>
        <Typography variant="h4" className="action-banner-title">
          {title}
        </Typography>
        <Typography variant="paragraph-m" className="action-banner-description">
          {description}
        </Typography>
      </div>
      <Flex gap="1.5rem" align="center" className="action-banner-actions-container">
        {type !== "info" && (
          <Flex gap="0.5rem" align="center" className="action-banner-time-left-container">
            <Icon iconName="tabler/calendar-time" className="action-banner-icon" />
            <Typography variant="paragraph-m" className="action-banner-time-left-text">
              {isOverdue ? t("dataSubmissionBanner.overdue") : t("dataSubmissionBanner.due", { dueDate: dueDate?.format("MMM DD") })}
            </Typography>
          </Flex>
        )}
        <Button type="primary" className="action-banner-button" onClick={onClick}>
          {buttonLabel}
        </Button>
      </Flex>
    </Flex>
  );
};
